import { UseFormWatch } from "react-hook-form";

export default function IdentifierTab({ watch }: { watch: UseFormWatch<any> }) {
  const registeredBy = watch("card_registered_by");
  const registeredDate = watch("card_registered_datetime")?.slice(0, 10);
  return (
    <div className="cabinet_profileeditmodal-right-content">
      <div className="cabinet_profileeditmodal-right-content-text">
        <div className="cabinet_profileeditmodal-right-content-text-title">
          Идентификатор
        </div>
        <div className="cabinet_profileeditmodal-right-content-text-description">
          Персональная метка игрока
        </div>
      </div>
      <div className="identifierCard">
        <img
          src="/modal/Print_Identifier_Card.png"
          alt=""
          className="identifierCard_img"
        />
        <img
          src="/modal/IdentifierCard_logo.svg"
          alt=""
          className="identifierCard_logo"
        />
      </div>
      <div className="identifierCard_about">
        <div className="identifierCard_about_title">Кем зарегестрирован</div>
        <div className="identifierCard_about_description">
          {registeredBy || "-"}
        </div>
      </div>
      <div className="identifierCard_about">
        <div className="identifierCard_about_title">Дата регистрации</div>
        <div className="identifierCard_about_description">
          {registeredDate || "-"}
        </div>
      </div>
      <div className="identifierNotice">
        Посетите полигон с развёрнутым Киберштабом, подойдите к организатору
        и сообщите о необходимости выдать вам новый идентификатор для доступа
        к системе Киберштаб
      </div>
    </div>
  );
}
